import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/queues_monitor.template.htm';
import QueuesTable from 'text-loader!../templates/queues_monitor_table.template.htm';
import Collection from '../models/queues.paginated.collection.ts';
import 'dhtmlxMessage';
import Pagination from '../views/pagination.view.ts';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import popup from 'popup';
import i18n  from 'l10n';

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	queuesTable: Handlebars.compile(QueuesTable),
	superInitialize: GenericView.prototype.initialize,
    collection : null,
    userData: null,
	privilegeLevel: "",
	isFirstDisplay: true,
	lastSearchedText: "",
	initialize: function (options) {
        var self = this;

        //this.userData = options.data;
        //this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

        this.collection = new Collection();
        this.collection.url = 'rest/api/queues';
        this.collection.on( 'sync', this.successQueueData, this );
        this.collection.on( 'error', this.errorQueueData, this );
        this.collection.getFirstPage();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();

		this.$el.html(this.template());
	},
	events: {
        "keyup #search": "search",
        "click i.selectable": "openMonitor",
        "click #monitorBtn": "chooseMonitor"
	},
    search: function(event)
    {
        var element = $(event.currentTarget);
		var text = element.val().trim();

        if(this.lastSearchedText != text )
        {
            $.ajaxq.abort("DefaultQueue");
            this.lastSearchedText = text;
            if(i18n.lng() == "en")
                this.collection.url = 'rest/api/queues?q=' + encodeURIComponent("nameEnglish="+element.val().trim());
            else
                this.collection.url = 'rest/api/queues?q=' + encodeURIComponent("name="+element.val().trim());
            this.collection.getFirstPage();
        }
    },
    successQueueData: function()
    {
        var self = this;
        self.hideActionProgressBar();

        if(this.isFirstDisplay)
        {
            this.isFirstDisplay = false;
            this.render();
        }
        $('#table-container').html(this.queuesTable(
            {
                "queues" : this.collection.models,
                pageInfo : this.collection.info(),
            })
         );

        this.pagination = new Pagination({ collection : this.collection });
        this.pagination.render();
        $( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").off("click").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

        if(this.collection.models.length > 0)
        {
            $('#table-container').show();
            $('#pagination').show();
            $('#empty').hide();

			self.initializeTrs(this.showHideActionButton, "#dataTables");
        }
        else
        {
            $('#table-container').hide();
            $('#pagination').hide();
            $('#empty').show();
        }
    },
    showHideActionButton: function(flag) {
        GenericView.prototype.showHideActionButton(flag, "#monitorBtn", "#dataTables");
    },
    errorQueueData: function(collection, xhr, options)
    {
        this.onErrorHandler(collection, xhr, options);
    },
	openMonitor: function(e)
	{
	    var link = window.location.href.split("/#")[0] + "/#QueueMonitor/" + this.collection.models[$(e.currentTarget).data("index")].id;
        var params = {
            "url": link,
            "collection": this.collection,
             "_showProgressBar": self.showActionProgressBar,
             "_hideProgressBar": self.hideActionProgressBar,
             "_deleteBtn": $('#deleteBtn')
        }
        popup.show(i18n.t("pageHeader.queues_monitor"),link, "copy_link", params);
	},
    chooseMonitor: function()
    {
        var ids = "";
        $("#dataTables").find("td input:checked").each( function() {
            ids += ($(this).parent().data("id")) +",";
        });
        if (ids != "") ids = ids.substr(0, ids.length - 1);

        var link = window.location.href.split("/#")[0] + "/#QueueMonitor/" + ids;
        var params = {
            "url": "",
            "collection": this.collection,
             "_showProgressBar": self.showActionProgressBar,
             "_hideProgressBar": self.hideActionProgressBar,
             "_deleteBtn": $('#deleteBtn')
        }
        popup.show(i18n.t("pageHeader.queues_monitor"),link, "copy_link", params);
    }

});

